import React, { Component } from 'react'
import { hmoCost } from '@services/api'
import { Collapse } from 'antd'
const { Panel } = Collapse
import Row from './Row'
import NewPrices from './NewPrices'

export default class extends Component {
    state = { policies: {} }
    componentDidMount() {
        this.update()
    }
    update = () => {
        hmoCost.hmoCostPerAges().then(res => {
            let policies = {}
            res.data.map(policy => (policies[policy.id] = { price: [] }))

            res.data.map(policy => {
                const { id, name, company_name, age_from, age_to, hmoCostId, price, updated_by, updated_at } = policy
                policies[id] = {
                    name,
                    company_name,
                    price: [...policies[id].price, { updated_by, updated_at, age_to, age_from, price, hmoCostId }]
                }
            })
            this.setState({ policies })
        })
    }
    render() {
        return (
            <Collapse style={{ flexDirection: 'column' }} accordion>
                {Object.entries(this.state.policies).map(([id, policy]) => (
                    <Panel key={id} header={policy.name}>
                        <Collapse style={{ flexDirection: 'column' }} accordion>
                            <Panel header={'תמחר מחיר לפי גילאים נוכחיים'}>
                                {policy.price.map(pol => (
                                    <Row
                                        policy={pol}
                                        key={pol.hmoCostId}
                                        update={this.update}
                                        updatePolicy={hmoCost.updatePolicy}
                                    />
                                ))}
                            </Panel>
                            <Panel header={'תמחר חבילה מחדש'}>
                                <NewPrices policyId={+id} update={this.update} setNewAges={hmoCost.setNewAges} />
                            </Panel>
                        </Collapse>
                    </Panel>
                ))}
            </Collapse>
        )
    }
}
